/*
 * @Author: chenshouliang m17635645973@163.com
 * @Date: 2026-04-09 16:04:24
 * @LastEditors: chenshouliang m17635645973@163.com
 * @LastEditTime: 2026-04-16 11:07:29
 * @FilePath: /ganxibao_screen/src/router/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  createRouter,
  createWebHashHistory,
  type RouteLocationNormalized,
} from "vue-router";

declare module "vue-router" {
  interface RouteMeta {
    /** 浏览器标签页标题 */
    title?: string;
  }
}

const DEFAULT_DOCUMENT_TITLE = "全国运营中心";

function documentTitleFromRoute(to: RouteLocationNormalized): string {
  const leaf = to.matched[to.matched.length - 1];
  const t = leaf?.meta?.title;
  if (typeof t === "string" && t) return t;
  return typeof to.name === "string" && to.name ? to.name : DEFAULT_DOCUMENT_TITLE;
}

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/sequence_1",
      name: "全国运营中心",
      meta: { title: "全国运营中心" },
      component: () => import("../views/sequence_1/index.vue"),
    },
    {
      path: "/sequence_2",
      name: "实验室质控中心",
      meta: { title: "实验室质控中心" },
      component: () => import("../views/sequence_2/index.vue"),
    },
    {
      path: "/sequence_3",
      name: "科学监管平台",
      meta: { title: "科学监管平台" },
      component: () => import("../views/sequence_3/index.vue"),
    },
  ],
});

router.afterEach((to) => {
  document.title = documentTitleFromRoute(to);
});

export default router
